module.exports = __webpack_public_path__ + "static/01-ce85a56074b3c414b6dd4a013c39e731.png";